import {Page, Locator, expect} from "@playwright/test"
import {UiBaseLocators} from "./UiBaseLocators";
import {ConstantHelper} from "./ConstantHelper";

export class ScriptUiHelper extends UiBaseLocators{
  private readonly newJavascriptFileBtn: Locator;
  private readonly scriptTree: Locator;
  private readonly newFolderThreeDots: Locator;

  constructor(page: Page) {
    super(page);
    this.newJavascriptFileBtn = page.getByLabel('New Javascript file');
    this.scriptTree = page.locator('umb-tree[alias="Umb.Tree.Script"]');
    this.newFolderThreeDots = page.getByLabel('New Folder...');
  }

  async clickActionsMenuForScript(name: string) {
    await this.clickActionsMenuForName(name);
  }

  async createScriptFolder(folderName: string) {
    await this.clickCreateOptionsActionMenuOption();
    await this.newFolderThreeDots.click();
    await this.enterFolderName(folderName);
    await this.clickConfirmCreateFolderButton();
  }

  async clickActionsMenuAtRoot() {
    await this.clickActionsMenuForScript('Scripts');
  }

  async clickRootFolderCaretButton() {
    await this.clickCaretButtonForName('Scripts');
  }

  async clickNewJavascriptFileButton() {
    await this.newJavascriptFileBtn.click();
  }
  
  async waitForScriptToBeCreated() {
    await this.waitForNetworkToBeIdle();
  }

  async waitForScriptToBeDeleted() {
    await this.waitForNetworkToBeIdle();
  }

  async waitForScriptToBeRenamed() {
    await this.waitForNetworkToBeIdle();
  }
  
  // Will only work for root scripts
  async goToScript(scriptName: string) {
    await this.goToSection(ConstantHelper.sections.settings);
    await this.reloadScriptTree();
    await this.page.getByLabel(scriptName, {exact: true}).click();
  }

  async enterScriptName(scriptContent: string) {
    await expect(this.enterAName).toBeVisible();
    await this.enterAName.fill(scriptContent);
  }

  async enterScriptContent(scriptContent: string) {
    await expect(this.textAreaInputArea).toBeVisible();
    await this.textAreaInputArea.clear();
    await this.textAreaInputArea.fill(scriptContent);
  }

  async openScriptAtRoot(scriptName: string) {
    await this.reloadScriptTree();
    await this.page.getByLabel(scriptName, {exact: true}).click();
  }

  async reloadScriptTree() {
    await this.reloadTree('Scripts');
  }

  async isScriptRootTreeItemVisible(scriptName: string, isVisible: boolean = true, toReload: boolean = true){
    if (toReload) {
      await this.reloadScriptTree();
    }
    return expect(this.scriptTree.getByText(scriptName, {exact: true})).toBeVisible({visible: isVisible});
  }
}